import { jsx } from 'react/jsx-runtime';
import { SectionSkeleton } from '../../sections/SectionSkeleton/SectionSkeleton.js';
import { Navigation } from '../Navigation/Navigation.js';
import '../Page/InPageNavigationContext.js';
import { Page } from '../Page/Page.js';
import { main, top } from './navigationData.js';

/**
 * The PageSkeleton component.
 * @returns The PageSkeleton component
 */
var PageSkeleton = function () {
  return jsx(Page, {
    sections: [jsx(SectionSkeleton, {
      reference: "section-skeleton-header",
      background: "white"
    }, "section-skeleton-header")],
    navigation: jsx(Navigation, {
      main: main,
      top: top
    }),
    footer: null
  });
};

export { PageSkeleton };
//# sourceMappingURL=PageSkeleton.js.map
